import { render, staticRenderFns } from "./btnSubmit.vue?vue&type=template&id=994892ce&"
import script from "./btnSubmit.vue?vue&type=script&lang=js&"
export * from "./btnSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports